/* eslint-disable camelcase */
import { useMutation } from '@tanstack/react-query'
import { ReactQueryKeys } from '@/types'
import { useContext } from 'react'
import { AxiosContext } from '@/context/Axios'

export interface UpdateTopicParams {
  topicName: string
  topicDescription?: string
  /**
   * Required, not optional — the backend's `topicUpdate` action
   * (AjaxController::maintTopic -> updateTopic) does an unconditional
   * `UPDATE ... SET topicXData = :topicXData`, so any call that omits this
   * silently NULLs out the topic's existing topicXData (severing
   * `sourceAlbumId`/wizard data). Every caller must pass through the
   * topic's current `topicXData` unless it's deliberately changing it.
   */
  topicXData: string
}

export const useUpdateTopic = (topicID: string) => {
  const axios = useContext(AxiosContext)
  return useMutation({
    mutationKey: [ReactQueryKeys.UPDATE_TOPIC, topicID],
    mutationFn: async ({ topicName, topicDescription = '', topicXData }: UpdateTopicParams) => {
      const response = await axios.api.post('ajax/topics', {
        requestType: 'topicUpdate',
        'topicData[action]': 'update',
        'topicData[topicApplication]': 2,
        'topicData[topicName]': topicName,
        'topicData[topicDescription]': topicDescription,
        'topicData[topicXData]': topicXData,
        'topicData[topicID]': topicID,
        format: 'json',
      })
      return response.data
    },
  })
}
